// extracted by mini-css-extract-plugin
module.exports = {"title":"CompanyPageSectionTitle-module_title_07563"};